import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Button } from "@mui/material";

const AccessDeniedMessage = () => {
  const history = useHistory();
  const { t } = useTranslation();

  return (
    <main
      role="main"
      aria-labelledby="access-denied-title"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
      }}
    >
      <section
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "0.5rem",
        }}
      >
        <h1 id="access-denied-title">{t("errors.accessDenied.title")}</h1>
        <p>{t("errors.accessDenied.message")}</p>
        <Button onClick={() => history.goBack()} variant="text" color="inherit">
          {t("general.goBack")}
        </Button>
      </section>
    </main>
  );
};

export default AccessDeniedMessage;
